import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2, Check, Circle } from "lucide-react";
import { api } from "../../lib/api";

export const AdminMessages = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/admin/messages").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const toggle = async (id) => { await api.patch(`/admin/messages/${id}/read`); load(); };
  const remove = async (id) => {
    if (!window.confirm("Eliminare questo messaggio?")) return;
    await api.delete(`/admin/messages/${id}`);
    toast.success("Messaggio eliminato");
    load();
  };
  if (loading) return <p className="mono text-sm">Caricamento…</p>;
  if (!items.length) return <p data-testid="admin-messages-empty" className="text-[rgba(246,241,232,0.7)]">Nessun messaggio ricevuto.</p>;
  return (
    <ul data-testid="admin-messages-list" className="space-y-3">
      {items.map((m) => (
        <li key={m.id} data-testid={`admin-message-${m.id}`} className={`border rounded-md p-5 ${m.read ? "border-[var(--line)] bg-transparent" : "border-[rgba(193,154,75,0.4)] bg-[var(--ink-2)]"}`}>
          <div className="flex flex-wrap justify-between gap-3">
            <div>
              <p className="font-semibold text-lg">{m.name} {m.company && <span className="text-[rgba(246,241,232,0.7)] font-normal">· {m.company}</span>}</p>
              <p className="mono text-[12px] text-[rgba(246,241,232,0.7)] mt-1">{m.email}{m.phone && ` · ${m.phone}`} · {m.lang?.toUpperCase()} · {new Date(m.created_at).toLocaleString("it-IT")}</p>
              {m.service && <span className="inline-block mt-2 mono text-[11px] uppercase px-2 py-1 rounded bg-[rgba(193,154,75,0.15)] text-[var(--amber)]">{m.service}</span>}
            </div>
            <div className="flex items-start gap-2">
              <a data-testid={`admin-message-reply-${m.id}`} href={`mailto:${m.email}`} className="p-2 rounded-full border border-[var(--line)] hover:border-[var(--amber)]" title="Rispondi"><Mail className="w-4 h-4" /></a>
              <button data-testid={`admin-message-toggle-${m.id}`} onClick={() => toggle(m.id)} className="p-2 rounded-full border border-[var(--line)] hover:border-[var(--amber)]" title={m.read ? "Segna come non letto" : "Segna come letto"}>
                {m.read ? <Circle className="w-4 h-4" /> : <Check className="w-4 h-4" />}
              </button>
              <button data-testid={`admin-message-delete-${m.id}`} onClick={() => remove(m.id)} className="p-2 rounded-full border border-[var(--line)] hover:border-red-400 hover:text-red-300" title="Elimina"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
          <p className="mt-4 whitespace-pre-wrap text-[rgba(246,241,232,0.9)]">{m.message}</p>
        </li>
      ))}
    </ul>
  );
};
